<dialog-gala (clickClose)="hideModalSIG()">
  <span gala-dialog-titre>{{(isUpdateSIG) ? lgTradSIG.MODIFAGCL : lgTradSIG.CREAAGCL }}</span>
  @if (formSIG && user) {
    <form [formGroup]="formSIG" autocomplete="off">
      <div>
        <div class="row">
          <div class="col-6">
            <select-gala #selectSIG formControlName="SIG" [searchable]="true" [disabled]="isUpdateSIG"
              (selected)="selectCOSIG()" [options]="listeSIG" [label]="lgTradSIG.SIGCODE"
              bindLabel="COSIG" />
            </div>
            <div class="col-6"></div>
          </div>
          <div class="row">
            <div class="col-6">
              <date-gala [label]="lgTradSIG.DEBUT" [placeholder]="lgTradSIG.BEGINNINGDATE"
                formControlName="DDEBUT" [disabled]="isUpdateSIG" />
              </div>
              <div class="col-6">
                <date-gala [label]="lgTradSIG.FIN" [placeholder]="lgTradSIG.ENDDATE"
                  formControlName="DFIN" />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <input-gala formControlName="ANCIENCODE" [label]="lgTradSIG.ANCIENCODE"
                    (keydown)="util.lengthLessThan($event,3) && util.acceptOnlyNumber($event)" />
                  </div>
                </div>
              </div>
            </form>
          }
          <div gala-dialog-actions>
            @if (droitsAccess.write) {
              <button mat-stroked-button color="primary" (click)="addSIG()">{{lgTrad.ENR}}</button>
            }
            <button mat-stroked-button color="accent" (click)="hideModalSIG()">{{lgTrad.RET}}</button>
          </div>
        </dialog-gala>